module.exports = __webpack_public_path__ + "static/img/caijingshangmao-3.4737473f.svg";